// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__PoLzS","info":"UpdateTermsInfo_info__1Qlb1"};